import { Component, Prop, h } from '@stencil/core';
import ChevronLeft24 from '@carbon/icons/es/chevron--left/16';
import ChevronRight24 from '@carbon/icons/es/chevron--right/16';
import Add24 from '@carbon/icons/es/add/16';
import Fit16 from '@carbon/icons/es/fit-to-width/16';
import Checkmark16 from '@carbon/icons/es/checkmark/16';
import FitToHeight16 from '@carbon/icons/es/fit-to-height/16';
import Locked16 from '@carbon/icons/es/locked/16';


@Component({
  tag: 'resource-timeline-primary-bar',
  styleUrl: 'resource-timeline-primary-bar.css',
  shadow: true,
})
export class ResourceTimelinePrimaryBar {
  @Prop() gridBarTitle: string;
  @Prop() subTitle: string;
  @Prop() primaryActionClick: (event?: MouseEvent) => void;
  @Prop() primaryActionTitle: string;
  @Prop() secondaryActionClick: (event?: MouseEvent) => void;
  @Prop() secondaryActionTitle: string;
  @Prop() clickForward: () => void;
  @Prop() clickBackward: () => void;
  @Prop() clickToday: () => void;
  @Prop() customFitColumnClick?: (event?: MouseEvent) => void;
  @Prop() subtitleStatus: string;
  @Prop() subtitleStatusMappingClasses: { [key: string]: string } = {};
  @Prop() disablePrimaryAction: boolean;
  @Prop() disableSecondaryAction: boolean;
  @Prop() toggleGroupExpandAll: () => void;
  @Prop() showLockedIcon: boolean;

  render() {
    return (
      <div class="header-bar">
        <div class="title-section">
          {this.gridBarTitle || this.gridBarTitle === '' ? (
            <unity-typography class="title" variant="button">
              {this.gridBarTitle}{' '}
            </unity-typography>
          ) : (
            <udp-skeleton-loading width="200px"></udp-skeleton-loading>
          )}
          <div class="subtitle">
            {this.subTitle || this.subTitle === '' ? (
              <unity-typography variant="caption-text">{this.subTitle} </unity-typography>
            ) : (
              <udp-skeleton-loading width="200px"></udp-skeleton-loading>
            )}
            {this.subtitleStatus && <status-chip class="status-icon" statusValue={this.subtitleStatus} statusClasses={this.subtitleStatusMappingClasses}>
              {this.subtitleStatus}
            </status-chip>}
            {this.showLockedIcon && <stencil-icon-button class="lock-icon" noBackground darkIcon={true} icon={Locked16} noTooltip={true} showLabel={false}></stencil-icon-button>}
            
          </div>
        </div>
        <div class="button-section">
          <stencil-icon-button darkIcon={true} icon={Fit16} showLabel={false} noTooltip={true} onClick={this.customFitColumnClick}></stencil-icon-button>
          <stencil-icon-button darkIcon={true} icon={FitToHeight16} showLabel={false} noTooltip={true} onClick={this.toggleGroupExpandAll}></stencil-icon-button>
          {this.clickBackward && (
            <stencil-icon-button darkIcon={true} icon={ChevronLeft24} showLabel={false} noTooltip={true} onClick={this.clickBackward}></stencil-icon-button>
          )}
          {this.clickToday && (
            <stencil-icon-button tooltip="Current Date" noTooltip={true} onClick={this.clickToday}>
              Today
            </stencil-icon-button>
          )}
          {this.clickForward && (
            <stencil-icon-button darkIcon={true} icon={ChevronRight24} noTooltip={true} showLabel={false} onClick={this.clickForward}></stencil-icon-button>
          )}
          {this.secondaryActionClick && (
            <stencil-icon-button icon={Checkmark16} disabled={this.disableSecondaryAction} noTooltip={true} onClick={this.secondaryActionClick}>
              {this.secondaryActionTitle}
            </stencil-icon-button>
          )}
          {this.primaryActionClick && (
            <stencil-icon-button disabled={this.disablePrimaryAction} darkIcon={true} icon={Add24} noTooltip={true} onClick={this.primaryActionClick}>
              {this.primaryActionTitle}
            </stencil-icon-button>
          )}
        </div>
      </div>
    );
  }
}
